import {
  errorReasons,
  getAccountId,
  getEmployeeId,
  getRegisterId,
  getSaleId,
  getShopId,
} from '../utils';

const verificationFailureEvents = {
  [errorReasons.AGE]: 'VisualVerificationRejected',
  [errorReasons.EXPIRED]: 'DocumentExpired',
  [errorReasons.PIN]: 'OverridePinInvalid',
  [errorReasons.RIGHTS]: 'OverrideMissingRights',
  [errorReasons.DECLINED]: 'ManagerOverrideDeclined',
  [errorReasons.INVALID_DOCUMENT]: 'DocumentNotRecognized',
};

const useEventLog = () => {
  const submitEvent = async (reason) => {
    const failureReason = verificationFailureEvents[reason];

    if (!failureReason) return;

    const employeeID = getEmployeeId();
    const saleID = getSaleId();
    const shopID = getShopId();
    const registerID = getRegisterId();

    try {
      fetch(`API/Account/${getAccountId()}/EventLog.json`, {
        method: 'POST',
        mode: 'cors',
        credentials: 'same-origin',
        header: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          type: 'log',
          category: 'register',
          event: 'Sale.AgeVerification.Failure',
          name: '',
          details: JSON.stringify({
            userAgent: window.navigator.userAgent,
            reason: failureReason,
          }),
          employeeID,
          saleID,
          shopID,
          registerID,
        }),
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  };

  return {
    submitEvent,
  };
};

export { useEventLog };
